import { DataTypeEnum } from 'src/app/enums/dataType.enum';
import { ColumnDetails } from 'src/app/models/columnDetails.model';
import { Sample } from 'src/app/models/sample.model';
import { ColumnConfig } from 'src/app/shared/grid/core-grid/columnConfig.model';
import { escapeHtml } from 'src/app/shared/helpers/html-escape.helper';

export const SAMPLE_ENDPOINT_COLUMN_PREFIX = 'EndPoint.';

const ENDPOINT_FIELD_COLUMN_PREFIX = `${SAMPLE_ENDPOINT_COLUMN_PREFIX}f_`.toLowerCase();

const EMPTY_CELL = '-';

const NUMERIC_DATA_TYPES: readonly DataTypeEnum[] = [
  DataTypeEnum.Integer,
  DataTypeEnum.Long,
  DataTypeEnum.Double,
  DataTypeEnum.Decimal,
  DataTypeEnum.Float,
];

export function isSampleEndPointColumn(columnKey: string): boolean {
  return columnKey.toLowerCase().startsWith(ENDPOINT_FIELD_COLUMN_PREFIX);
}

/** The API types endpoint columns as `DataTypeEnum.ToString()`, but the grid filter UI keys off
 * 'number' / 'boolean' / 'string'. Dates stay 'string' because the API compares the stored bag
 * text, not a date range. */
export function toEndPointColumnType(dataType: DataTypeEnum | undefined): string {
  if (dataType !== undefined && NUMERIC_DATA_TYPES.includes(dataType)) return 'number';
  if (dataType === DataTypeEnum.Boolean) return 'boolean';
  return 'string';
}

export function buildSampleEndPointColumn(columnKey: string, details: ColumnDetails): ColumnConfig<Sample> {
  const bagKey = columnKey.substring(SAMPLE_ENDPOINT_COLUMN_PREFIX.length);
  return new ColumnConfig<Sample>({
    name: columnKey,
    displayName: details.displayName,
    cellTemplate: (sample) => {
      const value = sample.endPoint?.[bagKey];
      return value == null || value === '' ? EMPTY_CELL : escapeHtml(String(value));
    },
  });
}
